export const FETCHED_PAGES = 'FETCHED_PAGES';
export const PAGE_SEARCH_BY_TITLE = 'PAGE_SEARCH_BY_TITLE';
export const CLEAR_PAGE_SEARCH_FILTER = 'CLEAR_PAGE_SEARCH_FILTER';


// WEBPACK FOOTER //
// ./src/containers/page-picker/types.js